import { useEffect, useState } from "react";
import { DashboardSkeleton } from "../../../../Components/Loader/dashboardSkeleton";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

export const PluginCallback: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [cookies, setCookies, removeCookie] = useCookies();

  // useEffect(() => {
  //   console.log("cookies", cookies);
  //   if (cookies?.extscurl) {
  //     const url = cookies?.extscurl;

  //     removeCookie("extscurl", { path: "/" });
  //     window.location.href = url;
  //   } else {
  //     navigate("/influencer/dashboard");
  //   }
  // }, [cookies, removeCookie, navigate]);

  useEffect(() => {
    try {
      const url = cookies?.extscurl;
      if (url) {
        removeCookie("extscurl", { path: "/" });
        const currentParams = new URLSearchParams(window.location.search);
        const urlObj = new URL(url);
        currentParams.forEach((value, key) => {
          urlObj.searchParams.set(key, value);
        });

        window.location.href = urlObj.toString();
      } else {
        navigate("/influencer/dashboard");
      }
    } catch (error) {
      navigate("/influencer/dashboard");
    }
  }, [cookies, removeCookie, navigate]);

  return (
    <>
      {loading && (
        <div className="max-h-screen overflow-hidden">
          <DashboardSkeleton />
        </div>
      )}

      {!loading && (
        <div>
          <h1>Plugin Callback</h1>
        </div>
      )}
    </>
  );
};
